import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import { UPDATE_GIFTING_BNBL_MODAL, INITIALISE_BNBL_MODAL, UPDATE_BNBL_NUMBER_OF_ROOMS, UPDATE_BNBL_PACKAGE_VIEW } from './actionConstants'

interface BnblRoomPackage {
  numberOfRooms: number;
  packageView: OfferPackageOptionView;
}

export function updateBnblGifting(offerId: string, isGift: boolean) {
  return {
    type: UPDATE_GIFTING_BNBL_MODAL,
    offerId,
    isGift,
  }
}

export function initialiseBnblOfferModal(
  packages: BnblRoomPackage[],
  offerId: string,
  isGift: boolean,
) {
  return {
    type: INITIALISE_BNBL_MODAL,
    packages,
    offerId,
    isGift,
  }
}

export function updateBnblNumberOfRooms(numberOfRooms: number, offerId: string, packageUniqueKey: string) {
  return {
    type: UPDATE_BNBL_NUMBER_OF_ROOMS,
    numberOfRooms,
    offerId,
    packageUniqueKey,
  }
}

export function updateBnblPackageView(offerId: string, packageView: OfferPackageOptionView) {
  return {
    type: UPDATE_BNBL_PACKAGE_VIEW,
    offerId,
    packageView,
  }
}
